import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-packages',
  templateUrl: './change-packages.component.html',
  styleUrls: ['./change-packages.component.scss'],
})
export class ChangePackagesComponent implements OnInit {
  breadcrumbs: any;
  transferPackage: any = FormGroup;
  submitted: boolean = false;
  isSaved: boolean = false;
  disabledButton: boolean = false;
  flagErrors: boolean = false;
  message: string = '';
  offices: any[] = [];
  users: any[] = [];
  cabins: any[] = [];
  packageId: String | null = '';

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.packageId = this.route.snapshot.paramMap.get('id');
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de paquetes',
        path: '/packages/list',
        link: true,
      },
      {
        name: 'Transferir paquete',
        link: false,
      },
    ];

    this.validations();
    this.getOffices();
  }

  validations() {
    this.transferPackage = this.fb.group({
      userId: ['', [Validators.required]],
      userTempId: [''],
      cabinId: ['', [Validators.required]],
      cabinTempId: [''],
      officeId: ['', [Validators.required]],
    });
  }

  get f() {
    return this.transferPackage.controls;
  }

  getOffices() {
    this.api.get('offices').subscribe({
      next: (offices) => {
        this.offices = offices.offices;
      },
      error: (err) => {},
    });
  }

  getClients(officeId: number) {
    this.api.getById('clients/office', officeId).subscribe({
      next: (data) => {
        const users = data.data;
        const userFormat = users.map((client: any) => {
          return {
            value: client.id,
            label: client.name,
          };
        });
        this.users = [{ options: userFormat }];
      },
      error: (err) => {},
    });
  }

  getCabins(officeId: number) {
    const params = `${officeId}/1`;
    this.api.getById('getCabin/office', params).subscribe({
      next: (data) => {
        const cabins = data.data;
        const cabinData = cabins.map((cabin: any) => {
          return {
            value: cabin.id,
            label: cabin.name,
          };
        });
        this.cabins = [{ options: cabinData }];
      },
      error: (err) => {},
    });
  }

  officeSelected(evt: any) {
    const officeId = evt.target.value;
    this.getClients(officeId);
    this.getCabins(officeId);
  }

  setDataToUsers(evt: any) {
    const clientId = evt.value;
    this.transferPackage.patchValue({
      userId: clientId,
      userTempId: clientId,
    });
  }

  setDataToCabins(evt: any) {
    const cabinId = evt.value;
    this.transferPackage.patchValue({
      cabinId: cabinId,
      cabinTempId: cabinId,
    });
  }

  transferPackages() {
    this.submitted = true;
    this.flagErrors = false;

    if (this.transferPackage.invalid) {
      this.submitted = false;
      this.flagErrors = true;

      return;
    }

    const obj = {
      officeId: this.transferPackage.value.officeId,
      cabinId: this.transferPackage.value.cabinId,
      userId: this.transferPackage.value.userId,
    };

    this.api.update('package/transfer', Number(this.packageId), obj).subscribe({
      next: (data) => {
        if (data.error) {
          this.isSaved = false;
          this.flagErrors = true;
        } else {
          this.isSaved = true;
          this.flagErrors = false;
        }
        this.submitted = false;
        this.message = data.message;
        this.resetTransferForm();

        setTimeout(() => {
          this.message = '';
          this.isSaved = false;
          this.flagErrors = false;
        }, 3000);
      },
      error: (err) => {},
    });
  }

  resetTransferForm() {
    this.transferPackage.get('officeId').setValue('');
    this.transferPackage.patchValue({
      userId: '',
      userTempId: '',
      cabinId: '',
      cabinTempId: '',
    });
  }
}
